import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class ClientsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      country_list: [],
      groups_data: [],
      name_group: '',
      id: this.props.client_id,
      name: this.props.client_data.name,
      address: this.props.client_data.address,
      city: this.props.client_data.city,
      province: this.props.client_data.province,
      country_id: this.props.client_data.country_id,
      phone: this.props.client_data.phone,
      email: this.props.client_data.email,
      observations: this.props.client_data.observations,
      operator: this.props.client_data.operator,
      crew_approve: this.props.client_data.crew_approve,
      operator: this.props.client_data.operator,
      refuel_export_email: this.props.client_data.refuel_export_email,
      double_fluid_refill_approval: this.props.client_data.double_fluid_refill_approval
    };

    //bind específico
    this.edit = this.edit.bind(this);
    this.addGroup = this.addGroup.bind(this);

    // Handlers
    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined' && typeof newProps.client_data.name !== 'undefined') {
      this.setState({
        id: newProps.client_id,
        name: newProps.client_data.name,
        address: newProps.client_data.address,
        city: newProps.client_data.city,
        province: newProps.client_data.province,
        country_id: newProps.client_data.country_id,
        phone: newProps.client_data.phone,
        email: newProps.client_data.email,
        observations: newProps.client_data.observations,
        crew_approve: newProps.client_data.crew_approve,
        operator: newProps.client_data.operator,
        refuel_export_email: newProps.client_data.refuel_export_email,
        double_fluid_refill_approval: newProps.client_data.double_fluid_refill_approval,
      });
    }
    if(Array.isArray(newProps.country_list)) {
      this.setState({country_list: newProps.country_list});
    }
    if(Array.isArray(newProps.groups_data)) {
      this.setState({groups_data: newProps.groups_data});
    }
  }
  
  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      address: this.state.address,
      city: this.state.city,
      province: this.state.province,
      country_id: this.state.country_id,
      phone: this.state.phone,
      email: this.state.email,
      observations: this.state.observations,
      crew_approve: this.state.crew_approve,
      double_fluid_refill_approval: this.state.double_fluid_refill_approval,
      operator: this.state.operator,
      refuel_export_email: this.state.refuel_export_email
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cliente', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addGroup(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name_group,
      client_id: this.state.id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cliente/grupo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshGroups(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.edit}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Nome}:</label>
          <input type="text" name="name" className="form-control" placeholder={this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.placeholder.NomeDoCliente} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Pais}:</label>
          <Select
            className="form-field-name"
            name="country_id"
            value={this.state.country_id}
            searchable={true}
            placeholder={this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.placeholder.SelecionarPais}
            onChange={this.handleSelectChange.bind(this, 'country_id')}
            options={this.state.country_list}
          />    
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Endereco}:</label>
          <input type="text" name="address" className="form-control" placeholder={this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.placeholder.EnderecoDoCliente} value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Telefone}:</label>
          <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder={this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.placeholder.TelefoneDoCliente} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Cidade}:</label>
          <input type="text" name="city" className="form-control" placeholder={this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.placeholder.CidadeDoCliente} value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Email}:</label>
          <input type="text" name="email" className="form-control" placeholder={this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.placeholder.EmailDoCliente} value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Estado}:</label>
          <input type="text" name="province" className="form-control" placeholder={this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.placeholder.EstadoDoCliente} value={this.state.province} onChange={this.handleChange.bind(this, 'province')} />
        </div>
      </div>
      
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Observacoes}:</label>
          <input type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
        </div>
      </div>
    </div>
    
    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.Operador}?</label>
          <br/>
          <Toggle
            checked={this.state.operator}
            aria-label=''
            name="operator"
            onChange={this.handleToggleChange.bind(this, 'operator')} />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.ExigeAprovacaoDosTripulantes}?</label>
          <br/>
          <Toggle
            checked={this.state.crew_approve}
            aria-label=''
            name="crew_approve"
            onChange={this.handleToggleChange.bind(this, 'crew_approve')} />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.RequerDuplaAprovacaoFluidosEDB}</label>
          <br/>
          <Toggle
            checked={this.state.double_fluid_refill_approval}
            aria-label=''
            name="double_fluid_refill_approval"
            onChange={this.handleToggleChange.bind(this, 'double_fluid_refill_approval')} />
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Clientes.EditarCliente.tabDadosDoCliente.formulario.botaoSalvarEdicao}</button>
      </div>
    </div>
  </form>
  <hr/>
  <h3>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.adicionarNovoGrupo}</h3>
  <form onSubmit={this.addGroup}>
    <div className="form-group">
      <label>{this.locale.Clientes.EditarCliente.tabDadosDoCliente.formularioNovoGrupo.Nome}:</label>
      <input type="text" name="name_group" className="form-control" placeholder={this.locale.Clientes.EditarCliente.tabDadosDoCliente.formularioNovoGrupo.placeholder.NomeDoGrupo} value={this.state.name_group} onChange={this.handleChange.bind(this, 'name_group')} />
    </div>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Clientes.EditarCliente.tabDadosDoCliente.formularioNovoGrupo.botaoSalvarGrupo}</button>
  </form>
</div>
    );
  }
}

export default ClientsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Clients/Elements/ClientsEditTab.js